export default __webpack_public_path__ + "static/media/mern-blog-480.6af4a54b.jpg";